<template>
  <div
    class="default-logo"
  >
    <img
      :src="require('@/assets/images/company.png')"
    >
  </div>
</template>

<script>
export default {
  name: 'DefaultLogo'
}
</script>

<style lang="stylus" scoped>
@import '~css/common/main'

.default-logo {
  width: 100px
  height: 100px
  background: $pink-color
  display: flex
  justify-content: center
  align-items: center

  img {
    display: block
    width: 60px
    height: 60px
    filter: drop-shadow(0px 0px 2px rgba(#000, .25))
  }
}
</style>
